module.exports = __webpack_public_path__ + "media/images/redesign-images/cm/ma-header-image-md-4a2b9a83133ebfed02fded21bf546e3d.jpg";